import { FORM_ACTIONS } from './actionTypes'

export const CertificatesFormStateSelectors = {
	create: state => state.products[FORM_ACTIONS.CREATE],
}
